import { render, staticRenderFns } from "./VenuePerformance.vue?vue&type=template&id=474bc9f8&"
import script from "./VenuePerformance.vue?vue&type=script&lang=js&"
export * from "./VenuePerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports